export default function createSeoConfig(description) {
  return {
    description,
    openGraph: {
      description,
      images: [
        {
          url: 'https://cdn.ticketswap.com/static/images/share-cover.png',
          width: 1200,
          height: 630,
          alt: 'TicketSwap',
        },
      ],
      type: 'website',
    },
    twitter: {
      handle: '@TicketSwap',
      site: '@TicketSwap',
      cardType: 'summary_large_image',
    },
  }
}
